<template>
  <section-divider-fi
    :fields="fields"
    :mark-ssr-only="markSsrOnly"
    size="small"
  />
</template>

<script>
import SectionDividerFi from './SectionDividerFi.vue';

export default {
  name: 'SectionDividerSmallFi',
  components: { SectionDividerFi },
  props: {
    fields: {
      type: Object,
      default: null,
    },
    markSsrOnly: {
      type: Function,
      default: null,
    },
  },
};
</script>
